export default {
  // Page metadata
  'meta.title': '服务条款 - timer.today',
  'meta.description': 'timer.today在线计时工具平台的服务条款和使用协议。了解我们的服务规则、用户权利和责任。',
  
  // Page header
  'page.title': '服务条款',
  'page.lastUpdated': '最后更新：{{date}}',
  'page.intro': '欢迎使用timer.today。这些条款和条件概述了使用timer.today网站（位于timer.today）的规则和规定。',

  // Section 1
  'section1.title': '1. 条款接受',
  'section1.content': '通过访问和使用本网站，您接受并同意受本协议条款和条件的约束。如果您不同意遵守上述条款，请不要使用此服务。',

  // Section 2
  'section2.title': '2. 服务描述',
  'section2.intro': 'timer.today提供免费的在线计时工具，包括：',
  'section2.timer': '倒计时器 - 可定制的计时器，适用于提高工作效率、烹饪和时间管理',
  'section2.stopwatch': '秒表 - 高精度计时工具，适用于运动、训练和精确计时',
  'section2.worldclock': '世界时钟 - 实时显示全球时区',

  // Section 3
  'section3.title': '3. 使用许可',
  'section3.intro': '授予您临时使用timer.today进行个人、非商业性临时查看的权限。这是许可的授予，不是所有权的转让，在此许可下您不得：',
  'section3.item1': '修改或复制材料',
  'section3.item2': '将材料用于任何商业目的或任何公开展示',
  'section3.item3': '尝试对网站上包含的任何软件进行逆向工程',
  'section3.item4': '从材料中删除任何版权或其他专有标记',

  // Section 4
  'section4.title': '4. 隐私和数据',
  'section4.intro': 'timer.today致力于保护您的隐私：',
  'section4.item1': '我们不收集或存储个人信息',
  'section4.item2': '计时器设置存储在您的浏览器本地',
  'section4.item3': '我们不跟踪用户行为或使用模式',
  'section4.item4': '不使用cookie进行跟踪',

  // Section 5
  'section5.title': '5. 免责声明',
  'section5.content': 'timer.today上的材料按"现状"提供。timer.today不提供任何明示或暗示的保证，并在此否认和否定所有其他保证，包括但不限于适销性、特定用途适用性的暗示保证或条件，或不侵犯知识产权或其他权利侵犯。',

  // Section 6
  'section6.title': '6. 责任限制',
  'section6.content': '在任何情况下，timer.today或其供应商都不对因使用或无法使用timer.today上的材料而产生的任何损害（包括但不限于数据丢失或利润损失，或业务中断造成的损害）承担责任，即使timer.today或其授权代表已被口头或书面通知可能发生此类损害。',

  // Section 7
  'section7.title': '7. 材料准确性',
  'section7.content': 'timer.today上显示的材料可能包含技术、排版或照片错误。timer.today不保证其网站上的任何材料准确、完整或最新。timer.today可能随时更改其网站上包含的材料，恕不另行通知。',

  // Section 8
  'section8.title': '8. 修改',
  'section8.content': 'timer.today可能随时修改其网站的这些服务条款，恕不另行通知。通过使用此网站，您同意受当前版本的这些服务条款的约束。',

  // Section 9
  'section9.title': '9. 联系信息',
  'section9.intro': '如果您对这些服务条款有任何疑问，请通过以下方式联系我们：',
  'section9.email': '邮箱：',
  'section9.emailSubject': '服务条款咨询 - timer.today',

  // Footer
  'footer.copyright': '© timer.today 2024. 保留所有权利。'
};